import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const cspConfigTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'CSP Configuration',
  key: 'CSP_CONFIG',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'name',
            'cspid',
          ],
          [
            'legalcontact',
            'nwcontact',
          ],
        ],
      },
    },
    fields: {
      name: {
        label: 'Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 64,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?&'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?&. Please re-enter.',
            },
          ],
        },
      },
      cspid: {
        label: 'CSP Identifier (ETSI EndpointID)',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      // The contact options are filled in by the Create/Edit/View containers from the
      // contacts known to the system - see getContactOptions.
      legalcontact: {
        label: 'Legal Contact',
        type: 'select',
        initial: '',
        options: [],
      },
      nwcontact: {
        label: 'Network Contact',
        type: 'select',
        initial: '',
        options: [],
      },
    },
  },
};

export default cspConfigTemplate;
